import { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import api from '../api/client';

export default function AdminRoute({ children }) {
  const [isAdmin, setIsAdmin] = useState(null);
  const accessToken = sessionStorage.getItem('access_token');

  useEffect(() => {
    if (!accessToken) return;

    api.get('/user/my')
    .then(response => {
      setIsAdmin(response.data.default_role === 'admin');
    })
    .catch(() => {
      setIsAdmin(false);
    });
  }, [accessToken]);

  if (!accessToken) {
    return <Navigate to="/gf-admin" replace />;
  }

  if (isAdmin === null) {
    return null;
  }

  if (!isAdmin) {
    sessionStorage.clear();
    return <Navigate to="/gf-admin" replace />;
  }

  return children;
}
